<div class="button-holder">
  <a
    [routerLink]="['/', DOCUMENT_PATH, {outlets: {item: 'add'}}]"
    mat-flat-button routerLink="dokument">
    {{ buttonText() }}
  </a>
</div>